import { createCustomSearchParamsUpdater } from '@gonfalon/router/createCustomSearchParamsUpdater';

import { parseProjectContextSearchParams } from './parseProjectContextSearchParams';
import { serializeProjectContextSearchParams } from './serializeProjectContextSearchParams';

export const projectContextSearchParamsUpdater = createCustomSearchParamsUpdater({
  parse: parseProjectContextSearchParams,
  serialize: serializeProjectContextSearchParams,
});
